.media-default-skin {
  --media-popup-transition:
    opacity var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    filter var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    transform var(--media-popup-transition-timing-function) var(--media-popup-transition-duration),
    scale var(--media-popup-transition-timing-function) var(--media-popup-transition-duration);
}

.media-default-skin .media-popover,
.media-default-skin .media-tooltip {
  --media-popup-translate-distance: calc(0.5 * var(--media-internal-scale-unit));
  margin: 0;
  overflow: visible;
  color: inherit;
  border: 0;
  transition: var(--media-popup-transition);

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
    filter: blur(4px);
    /* We have to use transform here for translate as the translate property is used for positioning by core. */
    transform: translate(var(--media-popup-translate-x-distance, 0), var(--media-popup-translate-y-distance, 0));
    scale: 0.95;
  }

  &[data-ending-style] {
    transform: none;
    /* Speed up the exit transition. */
    transition-duration: max(0ms, calc(var(--media-popup-transition-duration) - 50ms));
  }

  &[data-side="top"] {
    --media-popup-translate-y-distance: var(--media-popup-translate-distance);
    transform-origin: bottom;
  }
  &[data-side="bottom"] {
    --media-popup-translate-y-distance: calc(var(--media-popup-translate-distance) * -1);
    transform-origin: top;
  }
  &[data-side="left"] {
    --media-popup-translate-x-distance: var(--media-popup-translate-distance);
    transform-origin: right;
  }
  &[data-side="right"] {
    --media-popup-translate-x-distance: calc(var(--media-popup-translate-distance) * -1);
    transform-origin: left;
  }

  /* Safe area between trigger and popup */
  &::before {
    position: absolute;
    pointer-events: inherit;
    content: "";
  }

  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    inset-inline: 0;
    width: 100%;
  }
  &[data-side="top"]::before {
    top: 100%;
  }
  &[data-side="bottom"]::before {
    bottom: 100%;
  }

  &[data-side="left"]::before,
  &[data-side="right"]::before {
    inset-block: 0;
    height: 100%;
  }
  &[data-side="left"]::before {
    left: 100%;
  }
  &[data-side="right"]::before {
    right: 100%;
  }
}

.media-default-skin .media-popover {
  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    height: var(--media-popover-side-offset);
  }
  &[data-side="left"]::before,
  &[data-side="right"]::before {
    width: var(--media-popover-side-offset);
  }
}
.media-default-skin .media-popover--volume {
  padding: calc(var(--media-spacing) * 3) 0;
  border-radius: calc(Infinity * 1px);

  &:has(media-volume-slider[data-hidden]) {
    display: none;
  }
}

.media-default-skin .media-tooltip {
  padding: calc(var(--media-spacing) * 1) calc(var(--media-spacing) * 2.5);
  font-size: var(--media-font-size-base);
  white-space: nowrap;
  border-radius: calc(Infinity * 1px);

  /* `display: flex` must not apply while closed — it overrides UA `[popover]` hiding. */
  &[data-open] {
    display: flex;
    column-gap: calc(var(--media-spacing) * 1);
    align-items: center;
  }

  &[data-side="top"]::before,
  &[data-side="bottom"]::before {
    height: var(--media-tooltip-side-offset);
  }
  &[data-side="left"]::before,
  &[data-side="right"]::before {
    width: var(--media-tooltip-side-offset);
  }

  .media-tooltip__kbd {
    min-width: 1.5em;
    padding: 0.1em;
    font-family: inherit;
    font-size: var(--media-font-size-small);
    font-weight: 600;
    line-height: 1.25;
    text-align: center;
    background-color: oklch(from currentColor l c h / 0.3);
    border-radius: calc(var(--media-spacing) * 1);
  }
}
